/**
 * Читабельний опис фактури KSeF для поля driver_invoices.note.
 * Формат: 2026-09-10 · Orlen · WA12345 · fv 123/09/2026 · KSeF ... · VAT 23.00 · zwrot 8.50
 */

export const formatKsefMoney = (value) => {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return n.toFixed(2);
};

const calendarDate = (value) => {
  if (!value) return "";
  const str = String(value).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(str) ? str : "";
};

export const computeKsefRefund = (vatAmount, invoiceFee = 0, refundPercent = 50) => {
  const vatNum = vatAmount != null ? Number(vatAmount) : null;
  if (vatNum == null || Number.isNaN(vatNum)) return null;
  const fee = Number(invoiceFee) || 0;
  const percent = refundPercent != null ? Number(refundPercent) : 50;
  return Math.max(Math.round((vatNum * (percent / 100) - fee) * 100) / 100, 0);
};

export const buildKsefInvoiceNote = (invoice, extras = {}) => {
  const payload = invoice && typeof invoice === "object" ? invoice : {};
  const issueDate = calendarDate(payload.issueDate || payload.invoicingDate || extras.issue_date);
  const seller = payload.seller?.name || payload.thirdSubjects?.[0]?.name || extras.seller || "";
  const plate = extras.plate || "";
  const invoiceNumber = payload.invoiceNumber || extras.invoice_number || "";
  const ksefNumber = payload.ksefNumber || extras.ksef_number || "";
  const vat = formatKsefMoney(payload.vatAmount ?? extras.vat_amount);
  const refund = formatKsefMoney(extras.refund_amount);

  const parts = [];
  if (issueDate) parts.push(issueDate);
  if (seller) parts.push(seller);
  if (plate) parts.push(plate);
  if (invoiceNumber) parts.push(`fv ${invoiceNumber}`);
  if (ksefNumber) parts.push(`KSeF ${ksefNumber}`);
  if (vat) parts.push(`VAT ${vat}`);
  if (refund != null) parts.push(`zwrot ${refund}`);
  return parts.join(" · ");
};
